import { useEffect, useRef } from "react";

/**
 * Embeds the official CQC widget for our location.
 * Source: https://www.cqc.org.uk — the script renders the live rating
 * card inline where it is mounted.
 */
export const CqcWidget = ({ className = "" }) => {
  const ref = useRef(null);

  useEffect(() => {
    const container = ref.current;
    if (!container) return;

    // Avoid double-injection on route re-mounts.
    container.innerHTML = "";

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "https://www.cqc.org.uk/sites/all/modules/custom/cqc_widget/widget.js?data-id=1-2866375604&data-host=https://www.cqc.org.uk&type=location";
    script.async = true;
    container.appendChild(script);

    return () => {
      container.innerHTML = "";
    };
  }, []);

  return (
    <div
      ref={ref}
      data-testid="cqc-widget"
      className={`cqc-widget-host bg-white rounded-2xl border border-brand-line p-4 min-h-[120px] flex items-center justify-center ${className}`}
    />
  );
};
